import * as React from 'react'
import { Theme } from '@120wateraudit/envirio-components'
import '@120wateraudit/envirio-components/src/styles.css'
import 'noty/lib/noty.css'
import 'rc-calendar/assets/index.css'
import 'rc-time-picker/assets/index.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-select/dist/react-select.css'
import { Navigation } from '../Navigation/Navigation'
import { Footer } from '../Footer/Footer'
import 'react-placeholder/lib/reactPlaceholder.css'
import FullStory from 'react-fullstory'

interface Props {
  title?: string
}

// What `next/head` held is now split: the tags that never change (GTM, Typekit,
// favicon, Semantic's stylesheet) are static in index.html, and the one that does
// -- the per-account title -- is set here.
export const Layout: React.FunctionComponent<
  React.PropsWithChildren<Props>
> = ({ children, title = '120Water - PTD Dashboard' }) => {
  React.useEffect(() => {
    document.title = title
  }, [title])

  return (
    <div>
      <Theme>
        <Navigation accountName={title} />
        <FullStory org="JCMDS" />
        <div className="wrapper">{children}</div>
        <Footer />
      </Theme>
    </div>
  )
}
